import { CarFront, Send, FileCheck2 } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { Reveal, SectionHead } from "./Reveal";

const ICONS = [CarFront, Send, FileCheck2];

const HowItWorks = () => {
  const { t } = useLanguage();
  const steps = t("how.steps");

  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="mx-auto max-w-7xl scroll-mt-24 px-4 py-24 sm:px-6 lg:px-8 lg:py-32">
      <SectionHead eyebrow={t("how.eyebrow")} title={t("how.title")} />
      <div className="mt-14 grid gap-6 md:grid-cols-3">
        {steps.map((step, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={i} delay={i * 0.12}>
              <div
                data-testid={`how-step-${i + 1}`}
                className="group relative h-full overflow-hidden rounded-3xl border border-white/[0.06] bg-panel p-8 transition-all duration-500 hover:border-gold/35 hover:shadow-[0_24px_70px_-24px_rgba(212,175,55,0.25)]"
              >
                <span className="pointer-events-none absolute -end-4 -top-6 font-display text-[7rem] font-bold leading-none text-white/[0.04] transition-colors duration-500 group-hover:text-gold/[0.08]">
                  0{i + 1}
                </span>
                <span className="flex h-12 w-12 items-center justify-center rounded-2xl border border-gold/25 bg-gold/10">
                  <Icon className="h-5 w-5 text-gold" aria-hidden="true" />
                </span>
                <h3 className="mt-6 font-display text-2xl font-semibold text-white">{step.t}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-400">{step.d}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
};

export default HowItWorks;
